const data = [
  {
    id: 1,
    title: "Joggers For women",
    price: 1600,
    category: "pant",
    img: "../assets/images/leather-clutch-bag-for-women-clutches-leather-bag-girls-ladies-clutch-purse-leather-crocodile-pattern-croc-bag-italian-leather-purse-black.jpg",
    quantity: 1,
    weather:"summer",
    feature: "eyneed",
  },
  {
    id: 2,
    title: "Floral Chiffon Skirt",
    price: 1800,
    category: "dress",
    img: "../assets/images/25f5b6a7-ce25-4e66-8a61-3aa2037b6c741600207614629-1.jpg",
    quantity: 1,
    weather:"summer",
    feature: "myfp",
  },
  {
    id: 3,
    title: "Leather Boot",
    price: 3500,
    category: "shoes",
    img: "../assets/images/0dc73ba43ecaa92a2823188ca04793fc.jpeg",
    quantity: 1,
    weather:"winter",
    feature: "hot",
  },
  {
    id: 4,
    title: "Hoop Earrings",
    category: "access",
    price: 1200,
    img: "../assets/images/50241523fg_13_n_f.jpg",
    quantity: 1,
    weather:"none",
    feature: "myfp",
  },
  {
    id: 5,
    title: "Party lehenga",
    category: "dress",
    price: 12000,
    img: "../assets/images/Lehenga-Designs-The-Crimson-Bride-1-768x945.jpg",
    quantity: 1,
    weather:"none",
    feature: "eyneed",
  },
  {
    id: 6,
    title: "Pink lehenga",
    price: 13000,
    category: "dress",
    img: "../assets/images/07-10-20TORANI33955_600x.jpg",
    quantity: 1,
    weather:"none",
    feature: "myfp",
  },
  {
    id: 7,
    title: "Floral Top",
    price: 1500,
    category: "dress",
    img: "../assets/images/35YP97-600x800.jpg",
    quantity: 1,
    weather:"summer",
    feature: "trending",
  },
  {
    id: 8,
    title: "Green Sari",
    price: 2500,
    category: "dress",
    img: "../assets/images/2395sr18-sw-518.jpg",
    quantity: 1,
    weather:"none",
    feature: "eyneed",
  },
  {
    id: 9,
    title: "Silk Gown",
    price: 9000,
    category: "dress",
    img: "../assets/images/05002-0392_1_750x.jpg",
    quantity: 1,
    weather:"none",
    feature: "trending",
  },
  {
    id: 10,
    title: "Some kind of pant",
    price: 1500,
    category: "pant",
    img: "../assets/images/00390133-04.jpg",
    quantity: 1,
    weather:"summer",
    feature: "vibe",
  },
  {
    id: 11,
    title: "White dress",
    price: 3000,
    category: "dress",
    img: "../assets/images/00434231-01.jpg",
    quantity: 1,
    weather:"summer",
    feature: "myfp",
  },
  {
    id: 12,
    title: "Backless black dress",
    price: 4000,
    category: "dress",
    img: "../assets/images/157052696872633f9c489d7023a8acb11be2ac3d12.jpg",
    quantity: 1,
    weather:"summer",
    feature: "hot",
  },
  {
    id: 13,
    title: "Party shiny Gown",
    price: 8000,
    category: "dress",
    img: "../assets/images/bmg19064l_black_hickory_ombre_front.jpg",
    quantity: 1,
    weather:"none",
    feature: "eyneed",
  },
  {
    id: 14,
    title: "Cross Bag",
    price: 3000,
    category: "bags",
    img: "../assets/images/Cross bag.jpg",
    quantity: 1,
    weather:"none",
    feature: "eyneed",
  },
  {
    id: 15,
    title: "Fendi Blue Bag",
    price: 4000,
    category: "bags",
    img: "../assets/images/Fendi Blue Bag.jpg",
    quantity: 1,
    weather:"none",
    feature: "trending",
  },
  {
    id: 16,
    title: "High Spirited Bag",
    price: 2000,
    category: "bags",
    img: "../assets/images/High Spirited Bags.jpg",
    quantity: 1,
    weather:"none",
    feature: "trending",
  },
  {
    id: 17,
    title: "Forever Young wallet",
    price: 1800,
    category: "bags",
    img: "../assets/images/Forever young wallet.jpeg",
    quantity: 1,
    weather:"none",
    feature: "eyneed",
  },
  {
    id: 18,
    title: "Forever Sunny Pink",
    price: 8000,
    category: "bags",
    img: "../assets/images/Forever Sunny Pink.jpeg",
    quantity: 1,
    weather:"none",
    feature: "myfp",
  },
  {
    id: 19,
    title: "American Diamond",
    price: 8000,
    category: "access",
    img: "../assets/images/americandiamond.jpg",
    quantity: 1,
    weather:"none",
    feature: "myfp",
  },
  {
    id: 20,
    title: "Moon Stone",
    price: 8000,
    category: "access",
    img: "../assets/images/moonstone.jpg",
    quantity: 1,
    weather:"none",
    feature: "hot",
  },
  {
    id: 21,
    title: "Pink Knot",
    price: 8000,
    category: "access",
    img: "../assets/images/pinkknot.jpg",
    quantity: 1,
    weather:"none",
    feature: "myfp",
  },
  {
    id: 22,
    title: "Shiny Diamond Set",
    price: 8000,
    category: "access",
    img: "../assets/images/Shiny diamond set.png",
    quantity: 1,
    weather:"none",
    feature: "eyneed",
  },
  {
    id: 23,
    title: "Cute Tote Bag",
    price: 8000,
    category: "bags",
    img: "../assets/images/Cute tote bag.jpg",
    quantity: 1,
    weather:"none",
    feature: "hot",
  },
  {
    id: 24,
    title: "Denim Shorts",
    price: 8000,
    category: "pant",
    img: "../assets/images/Denim shorts.jpg",
    quantity: 1,
    weather:"summer",
    feature: "vibe",
  },
  {
    id: 25,
    title: "Grey Joggers",
    price: 8000,
    category: "pant",
    img: "../assets/images/Grey Joggers.jpg",
    quantity: 1,
    weather:"summer",
    feature: "vibe",
  },
  {
    id: 26,
    title: "High Rise Black pant",
    price: 8000,
    category: "pant",
    img: "../assets/images/High rise black pant.jpg",
    quantity: 1,
    weather:"summer",
    feature: "eyneed",
  },
  {
    id: 27,
    title: "Waist Cargo",
    price: 8000,
    category: "pant",
    img: "../assets/images/Waist Cargo.jpeg",
    quantity: 1,
    weather:"summer",
    feature: "eyneed",
  },
  {
    id: 28,
    title: "Canvas Sneakers",
    price: 4000,
    category: "shoes",
    img: "../assets/images/Canvas Sneakers.jpg",
    quantity: 1,
    feature: "vibe",
  },
  {
    id: 29,
    title: "Cute White Sandals",
    price: 2000,
    category: "shoes",
    img: "../assets/images/Cute white sandal.jpg",
    quantity: 1,
    feature: "myfp",
  },
  {
    id: 30,
    title: "Dye Sneakers",
    price: 42000,
    category: "shoes",
    img: "../assets/images/Dye Sneakers.png",
    quantity: 1,
    feature: "trending",
  },
  {
    id: 31,
    title: "Korean Thick Shoes",
    price: 2000,
    category: "shoes",
    img: "../assets/images/Korean thick shoes.jpg",
    quantity: 1,
    feature: "eyneed",
  },
  {
    id: 32,
    title: "Pearl Beading Sandals",
    price: 5500,
    category: "shoes",
    img: "../assets/images/pearl beading sandals.jpg",
    quantity: 1,
    feature: "vibe",
  },
  {
    id: 33,
    title: "Pencil Heels",
    price: 5000,
    category: "shoes",
    img: "../assets/images/Pencil Heels.jpg",
    quantity: 1,
    feature: "eyneed",
  },
  {
    id: 34,
    title: "Flat Sneakers",
    price: 33000,
    category: "shoes",
    img: "../assets/images/Flat Sneakers.jpg",
    quantity: 1,
    feature: "eyneed",
  },
  {
    id: 35,
    title: "Knee Length Boot",
    price: 62000,
    category: "shoes",
    img: "../assets/images/Knee length boot.jpg",
    quantity: 1,
    feature: "eyneed",
  },
  {
    id: 36,
    title: "Sports shoes",
    price: 3000,
    category: "shoes",
    img: "../assets/images/Sports shoes.jpeg",
    quantity: 1,
    feature: "eyneed",
  },
];

export default data;
